/**
 * Production-safe logging utility
 * Logs are silent in production, active in development
 */

const isDevelopment = import.meta.env.MODE === 'development';
const isDebug = import.meta.env.VITE_DEBUG === 'true';

export const logger = {
  /**
   * Log general information (development only)
   */
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Log errors (always logged, sent to monitoring in production)
   */
  error: (message: string, error?: Error | unknown, context?: Record<string, any>) => {
    const errorMessage = error instanceof Error ? error.message : String(error);
    const errorStack = error instanceof Error ? error.stack : undefined;

    // Always log errors to console
    console.error(message, error, context);

    // TODO: Send to Sentry in production
    if (!isDevelopment) {
      // Sentry.captureException(error, {
      //   tags: { type: 'frontend-error' },
      //   contexts: { additional: context },
      // });
    }
  },

  /**
   * Log warnings (development only)
   */
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Debug logging (only when VITE_DEBUG=true)
   */
  debug: (...args: any[]) => {
    if (isDevelopment && isDebug) {
      console.debug('[DEBUG]', ...args);
    }
  },

  /**
   * Log info messages (development only)
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * Performance timing (development only)
   */
  time: (label: string) => {
    if (isDevelopment) {
      console.time(label);
    }
  },

  timeEnd: (label: string) => {
    if (isDevelopment) {
      console.timeEnd(label);
    }
  },

  /**
   * Group logging (development only)
   */
  group: (label: string) => {
    if (isDevelopment) {
      console.group(label);
    }
  },

  groupEnd: () => {
    if (isDevelopment) {
      console.groupEnd();
    }
  },
};

export default logger;
